// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_2yGeL,.left_1pCWR,.right_13AY9{position:relative;display:flex;align-items:center}.container_2yGeL{color:#272525;width:100%}.left_1pCWR>*,.right_13AY9>*{margin-left:15px}.left_1pCWR{flex:1}.right_13AY9>:last-child{margin-right:15px}.product-image_RaqGL{max-height:38px;max-width:38px}.product-title_2lA0S{font-size:13px;font-weight:400}", ""]);
// Exports
exports.locals = {
	"container": "container_2yGeL",
	"left": "left_1pCWR",
	"right": "right_13AY9",
	"product-image": "product-image_RaqGL",
	"product-title": "product-title_2lA0S"
};
module.exports = exports;
